module.exports = __webpack_public_path__ + "media/images/views/lp/recruiter/steps/rc-step01-035f6be37e01288491fbacaaa61dbb53.png";